import styled, { DefaultTheme } from 'styled-components';

import { AppStoreButtonProps } from './AppStoreButton.types';
import { DarkTheme, LightTheme } from 'src/packages/theme';

export const Container = styled.div<AppStoreButtonProps & { defaulttheme: DefaultTheme }>`
  display: flex;
  direction: ltr;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.defaulttheme.colors.background.secondary.BG1};
  width: ${(props) => props.width};
  min-width: ${(props) => props.minWidth};
  height: ${(props) => (props.variant === 'secondary' ? '40px' : '48px')};
  border-radius: 6px;
  padding: 0 20px;
  outline: none;
  border: ${(props) =>
    props.theme === 'light'
      ? `1px solid ${LightTheme.colors.border.darker}`
      : `1px solid ${DarkTheme.colors.border.lighter}`};
  cursor: pointer !important;
  gap: 8px;

  * {
    cursor: pointer !important;
  }
`;
